import React, { useEffect } from 'react';
import { analytics, trackEvent } from './utils/analytics';
import { ThemeButton } from './components/ThemeButton';
import { Disclaimer } from './components/Disclaimer';
import { useThemePlayer } from './hooks/useThemePlayer';
const VIDEO_ID = 'l2wj6lJtg_8';
const AUDIO_URL = 'https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/0c/8b/4e/0c8b4e78-283a-19ed-cc4c-42c818c19972/mzaf_4326770620945518223.plus.aac.p.m4a';
const SOURCE_URL = `https://www.youtube.com/watch?v=${VIDEO_ID}`;
const WALLPAPER = 'https://cdn.magicpatterns.com/patterns/generated-images/7a84b79a-a1d9-4abf-bd01-05500ce48fea.jpg';
export function App() {
  const {
    hostRef,
    status,
    progress,
    play,
    stop
  } = useThemePlayer(VIDEO_ID, AUDIO_URL);
  useEffect(() => {
    analytics.page().catch(() => {});
  }, []);
  const handlePlay = () => {
    play();
    trackEvent('theme_play');
  };
  const handleStop = () => {
    stop();
    trackEvent('theme_stop');
  };
  return <main className="relative flex min-h-full w-full flex-col items-center justify-center overflow-hidden bg-jungle font-sans" style={{
    backgroundImage: `url(${WALLPAPER})`,
    backgroundSize: '520px auto',
    backgroundRepeat: 'repeat'
  }} data-id="element-0" data-mp="23ti5fwt74ggi">
      <div className="absolute inset-0 bg-jungle-deep/45" aria-hidden="true" data-id="element-1" data-mp="3rdkie91luppe" />
      <h1 className="sr-only" data-id="element-2" data-mp="67yvnd9206b">The White Lotus theme button</h1>

      <div className="relative z-10 flex flex-1 items-center justify-center p-6" data-id="element-3" data-mp="7sxbo2oq39g">
        <ThemeButton status={status} progress={progress} fallbackUrl={SOURCE_URL} onPress={handlePlay} onStop={handleStop} data-id="element-4" data-mp="2zn6aquk6q9m6" />
      </div>

      <div className="relative z-10 px-4 pb-5" data-id="element-5" data-mp="38l8hzruihyhw">
        <Disclaimer sourceUrl={SOURCE_URL} data-id="element-6" data-mp="38kgl8dp6huq1" />
      </div>

      {/* Audio-only player, kept off-screen */}
      <div ref={hostRef} aria-hidden="true" className="pointer-events-none fixed -left-[9999px] top-0 h-[200px] w-[200px] opacity-0" data-id="element-7" data-mp="3dm5zs3bm0qiv" />
    </main>;
}